import Vue, { Component } from "vue";
import { Activity, LogCode } from "@/graphql/query/activity/feed";

import AssignAppUserLog from "./AssignAppUserLog.vue";
import ChangeBuildingGroupLog from "./ChangeBuildingGroupLog.vue";
import CreateAppUserLog from "./CreateAppUserLog.vue";
import CreateBuildingLog from "./CreateBuildingLog.vue";
import CreateFamilyKeyLog from "./CreateFamilyKeyLog.vue";
import CreateGroupLog from "./CreateGroupLog.vue";
import CreateRoomLog from "./CreateRoomLog.vue";
import CreateTelKeyLog from "./CreateTelKeyLog.vue";
import CreateUserLog from "./CreateUserLog.vue";
import DeleteAppUserLog from "./DeleteAppUserLog.vue";
import DeleteBuildingLog from "./DeleteBuildingLog.vue";
import DeleteGroupLog from "./DeleteGroupLog.vue";
import DeleteRoomLog from "./DeleteRoomLog.vue";
import DeleteTelKeyLog from "./DeleteTelKeyLog.vue";
import DeleteUserLog from "./DeleteUserLog.vue";
import FreeRoomLog from "./FreeRoomLog.vue";
import RemoteCloseLog from "./RemoteCloseLog.vue";
import RemoteOpenLog from "./RemoteOpenLog.vue";
import RemoveAppUserLog from "./RemoveAppUserLog.vue";
import RentRoomLog from "./RentRoomLog.vue";
import ResetAppUserLog from "./ResetAppUserLog.vue";
import ResetMeLog from "./ResetMeLog.vue";
import ResetUserLog from "./ResetUserLog.vue";
import TelCloseLog from "./TelCloseLog.vue";
import TelOpenLog from "./TelOpenLog.vue";
import UpdateAppUserLog from "./UpdateAppUserLog.vue";
import UpdateBuildingLog from "./UpdateBuildingLog.vue";
import UpdateGroupLog from "./UpdateGroupLog.vue";
import UpdateMeLog from "./UpdateMeLog.vue";
import UpdateRoomLog from "./UpdateRoomLog.vue";
import UpdateUserLog from "./UpdateUserLog.vue";

const LogComponents: { [key in LogCode]: Component } = {
  // app user
  create_app_user: CreateAppUserLog,
  reset_app_user: ResetAppUserLog,
  update_app_user: UpdateAppUserLog,
  delete_app_user: DeleteAppUserLog,
  assign_app_user: AssignAppUserLog,
  remove_app_user: RemoveAppUserLog,

  // group
  create_group: CreateGroupLog,
  update_group: UpdateGroupLog,
  delete_group: DeleteGroupLog,

  // user
  create_user: CreateUserLog,
  update_user: UpdateUserLog,
  delete_user: DeleteUserLog,
  reset_user: ResetUserLog,

  // me
  update_me: UpdateMeLog,
  reset_me: ResetMeLog,

  // building
  create_building: CreateBuildingLog,
  update_building: UpdateBuildingLog,
  change_building_group: ChangeBuildingGroupLog,
  delete_building: DeleteBuildingLog,

  // room
  create_room: CreateRoomLog,
  update_room: UpdateRoomLog,
  delete_room: DeleteRoomLog,

  // others
  create_family_key: CreateFamilyKeyLog,
  create_tel_key: CreateTelKeyLog,
  delete_tel_key: DeleteTelKeyLog,
  free_room: FreeRoomLog,
  rent_room: RentRoomLog,
  remote_open: RemoteOpenLog,
  remote_close: RemoteCloseLog,
  tel_open: TelOpenLog,
  tel_close: TelCloseLog
};

type Props = { activity: Activity };
export default Vue.component<Props>("activity-linked-text", {
  functional: true,
  props: {
    activity: { type: Object, required: true }
  },
  render: (createElement, context) => {
    const component = LogComponents[context.props.activity.code];
    if (component) {
      return createElement(component, {
        props: { activity: context.props.activity }
      });
    }
    return createElement("span", [context.props.activity.code]);
  }
});
